/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BuilderNavigationService, BuilderUserContext } from '@gh/builder-shared';
import {
  AelEvents,
  PRIVILEGED_EP_SYS_VARS_JOBS_DPP,
  PRIVILEGED_EP_SYS_VARS_JOBS_PERMIT_DATE,
} from '@gh/builder-shared-data';
import { getRouteInitData, TextDictionary, updatePrivilegedControls } from '@gh/common-shared';
import { AutocompleteLoadMoreEvent } from '@gh/core-ui';
import { assign } from 'lodash';
import { SystemVarsJobsBusinessService } from '../../../resources/system-vars-jobs-business.service';
import { SystemVarsJobsCommonSettingsSubTabFormState } from './sys-vars-jobs-common-settings-subtab.form.service';

@Component({
  standalone: false,
  selector: 'gh-system-vars-jobs-common-settings-tab',
  templateUrl: 'sys-vars-jobs-common-settings-subtab.component.html',
  styleUrls: ['sys-vars-jobs-common-settings-subtab.component.scss'],
})
export class SystemVarsJobsCommonSettingsSubTabComponent implements OnInit {
  contactBasedOnValues: TextDictionary;
  contractPeriodIncludes: TextDictionary;
  monthes = ['N/A', '3', '4', '5', '6', '7', '8', '9', '10', '12', '15', '18', '21', '24'];

  constructor(private route: ActivatedRoute,
              public form: SystemVarsJobsCommonSettingsSubTabFormState,
              private businessService: SystemVarsJobsBusinessService,
              private navigationService: BuilderNavigationService,
              private userContext: BuilderUserContext) {
  }

  ngOnInit(): void {
    assign(this, getRouteInitData(this.route));
  }

  loadCC($event: AutocompleteLoadMoreEvent): void {
    $event.load(this.businessService.loadCC($event.query));
  }

  onPrivilegedTokenReceivedDpp(): void {
    updatePrivilegedControls(this.form, PRIVILEGED_EP_SYS_VARS_JOBS_DPP);
  }

  onPrivilegedTokenReceivedPermitDate(): void {
    updatePrivilegedControls(this.form, PRIVILEGED_EP_SYS_VARS_JOBS_PERMIT_DATE);
  }

  goToAel(): void {
    this.navigationService.goToAel({
      entityId: this.userContext.office && this.userContext.office.id,
      entityType: 'OFFICE',
      eventTypeIds: [AelEvents.Office.EditedJobs],
      label: 'lbl_jobs',
    });
  }
}
